import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux'
import moment from 'moment'
import HttpService from '../../../services/httpService'
import { setLoading, setSnackInfo } from '../../../redux/actions/appAction'
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TablePagination from '@material-ui/core/TablePagination';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Drawer from '@material-ui/core/Drawer';
import Slide from '@material-ui/core/Slide';
import {
    Button, Box, Grid, TextField, IconButton, InputAdornment, CircularProgress, Chip,
} from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/core/styles';
// Material-UI icons throughout - the Ant Design set these replace was the odd
// one out against every other page in the app, and read as dated beside them.
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import AddIcon from '@material-ui/icons/Add';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SearchIcon from '@material-ui/icons/Search';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import CloseIcon from '@material-ui/icons/Close';
import InboxOutlinedIcon from '@material-ui/icons/InboxOutlined';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import RefreshIcon from '@material-ui/icons/Refresh';
import LinearProgress from '@material-ui/core/LinearProgress';
import Skeleton from '@material-ui/lab/Skeleton';

const ORANGE = "#F47E44";
const ORANGE_DARK = "#c1531f";
const ORANGE_LIGHT = "#fff1ea";
const HEADER_GRADIENT = `linear-gradient(135deg, ${ORANGE_DARK} 0%, ${ORANGE} 60%, #ff9c66 100%)`;
const RED = "#c0392b";
const RED_LIGHT = "#fdecea";
const HEADING_FONT = "'Silka bold', 'Silka semiBold', sans-serif !important";

// Warm, on-brand palette for the per-department avatar chips - cycled by index
const AVATAR_COLORS = [
    { bg: "#fff1ea", fg: "#c1531f" },
    { bg: "#fff4d6", fg: "#b8860b" },
    { bg: "#e8f6ef", fg: "#1e8a5f" },
    { bg: "#eaf1ff", fg: "#2c5fb8" },
    { bg: "#f5ecff", fg: "#7b3fd6" },
    { bg: "#ffeaf1", fg: "#c1315f" },
];

const getAvatarColor = (name = "") => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

// Reads a message out of an error response whether the backend sent
// `{ message: "..." }` or a plain string body - some department endpoints
// respond with a bare string on failure (e.g. "Department already exist.").
const extractErrorMessage = (error) => {
    const data = error?.response?.data;
    if (!data) return "Something went wrong";
    if (typeof data === "string") return data;
    return data.message || "Something went wrong";
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// Indeterminate bar shown while the list is being fetched. Same treatment as
// the Experience Centers / Locations pages, which share this orange palette,
// so they read as one system.
const BrandLinearProgress = withStyles(() => ({
    root: {
        height: 4,
        borderRadius: 999,
        backgroundColor: "rgba(193,83,31,0.10)",
    },
    bar: {
        borderRadius: 999,
        background: `linear-gradient(90deg, ${ORANGE_DARK}, ${ORANGE}, #ff9c66)`,
    },
}))(LinearProgress);

const useStyles = makeStyles({
    page: {
        padding: "4px 2px 24px",
    },
    headerCard: {
        position: "relative",
        background: HEADER_GRADIENT,
        borderRadius: 18,
        padding: "24px 28px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 16,
        marginBottom: 20,
        boxShadow: "0 10px 28px rgba(244, 126, 68, 0.3)",
        overflow: "hidden",
    },
    headerGlowOne: {
        position: "absolute",
        top: -60,
        right: -40,
        width: 180,
        height: 180,
        borderRadius: "50%",
        background: "rgba(255,255,255,0.12)",
        pointerEvents: "none",
    },
    headerGlowTwo: {
        position: "absolute",
        bottom: -70,
        right: 120,
        width: 140,
        height: 140,
        borderRadius: "50%",
        background: "rgba(255,255,255,0.08)",
        pointerEvents: "none",
    },
    headerLeft: {
        display: "flex",
        alignItems: "center",
        gap: 16,
        flexWrap: "wrap",
        position: "relative",
        zIndex: 1,
    },
    iconBadge: {
        width: 56,
        height: 56,
        borderRadius: 16,
        background: "rgba(255,255,255,0.22)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 28,
        color: "#fff",
        flexShrink: 0,
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.25)",
    },
    headerTitle: {
        color: "#fff",
        fontFamily: HEADING_FONT,
        fontSize: 23,
        margin: 0,
    },
    headerSubtitle: {
        color: "rgba(255,255,255,0.88)",
        fontSize: 13,
        margin: "4px 0 0",
    },
    statChip: {
        background: "rgba(255,255,255,0.22)",
        color: "#fff",
        fontWeight: 600,
        fontSize: 13,
        height: 30,
    },
    // Deliberately NOT the usual red: on this orange banner a red chip is both
    // low-contrast and easy to read as decoration. A solid dark fill with white
    // text separates it from the translucent stat chips beside it.
    warnChip: {
        background: "rgba(0,0,0,0.32)",
        color: "#fff",
        fontWeight: 700,
        fontSize: 13,
        height: 30,
        border: "1px solid rgba(255,255,255,0.45)",
        cursor: "help",
    },
    headerActions: {
        position: "relative",
        zIndex: 1,
        display: "flex",
        alignItems: "center",
        gap: 10,
        flexWrap: "wrap",
        justifyContent: "flex-end",
    },
    // Solid white with a ring rather than a translucent fill: white-on-gradient
    // at low opacity measures around 2:1 against the lighter end of this banner.
    refreshBtn: {
        background: "#fff",
        color: ORANGE_DARK,
        fontWeight: 700,
        borderRadius: 10,
        textTransform: "none",
        padding: "9px 18px",
        border: `1px solid ${ORANGE_DARK}`,
        boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
        "&:hover": { background: "#fff1ea" },
        "&.Mui-disabled": { background: "rgba(255,255,255,0.75)", color: ORANGE_DARK },
    },
    spin: { animation: "$spin 0.9s linear infinite" },
    "@keyframes spin": {
        from: { transform: "rotate(0deg)" },
        to: { transform: "rotate(360deg)" },
    },
    lastUpdatedText: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 6,
        fontSize: 12,
        fontWeight: 600,
        color: "rgba(255,255,255,0.92)",
    },
    liveDot: {
        width: 7,
        height: 7,
        borderRadius: "50%",
        background: "#8ef5b5",
        boxShadow: "0 0 0 3px rgba(142,245,181,0.25)",
    },
    // Always occupies the bar's height, whether or not the bar is showing.
    progressSlot: { height: 4, marginBottom: 10 },
    loadingBanner: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "9px 14px",
        marginBottom: 14,
        borderRadius: 12,
        background: ORANGE_LIGHT,
        border: `1px solid ${ORANGE}33`,
    },
    loadingBannerTitle: { fontSize: 13, fontWeight: 700, color: ORANGE_DARK },
    loadingBannerHint: { fontSize: 11.5, color: "#7a6a60", marginTop: 1 },
    // Dashed, not filled: reads as "something is missing here" rather than as
    // another value sitting in the column.
    noStageChip: {
        height: 24,
        fontSize: 12,
        fontWeight: 700,
        backgroundColor: RED_LIGHT,
        color: RED,
        border: `1px dashed ${RED}66`,
        cursor: "help",
    },
    addBtn: {
        background: "#fff",
        color: ORANGE_DARK,
        fontWeight: 700,
        borderRadius: 10,
        textTransform: "none",
        padding: "9px 22px",
        boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
        position: "relative",
        zIndex: 1,
        transition: "transform .15s ease",
        "&:hover": {
            background: "#fff1ea",
            transform: "translateY(-1px)",
        },
    },
    filterCard: {
        background: "#fff",
        borderRadius: 16,
        padding: "16px 20px",
        marginBottom: 20,
        boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
        display: "flex",
        alignItems: "center",
        gap: 14,
        flexWrap: "wrap",
    },
    sectionLabel: {
        fontSize: 12,
        fontWeight: 700,
        color: "#8a8a8a",
        textTransform: "uppercase",
        letterSpacing: 0.5,
        marginRight: 4,
    },
    searchField: {
        width: 300,
        "& .MuiOutlinedInput-root": {
            borderRadius: 10,
            "&.Mui-focused fieldset": {
                borderColor: ORANGE,
            },
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: ORANGE_DARK,
        },
    },
    clearBtn: {
        color: ORANGE_DARK,
        textTransform: "none",
        fontWeight: 600,
    },
    resultCount: {
        marginLeft: "auto",
        fontSize: 13,
        color: "#999",
    },
    tableCard: {
        borderRadius: 18,
        overflow: "hidden",
        boxShadow: "0 2px 14px rgba(0,0,0,0.07)",
    },
    tableScrollWrap: {
        maxHeight: "calc(100vh - 480px)",
        minHeight: 160,
        overflowY: "auto",
    },
    table: {
        minWidth: 700,
    },
    tableHeadCell: {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: ORANGE_DARK,
        color: "#fff",
        fontWeight: 700,
        fontSize: 13,
        letterSpacing: 0.3,
        border: "none",
    },
    sortLabel: {
        color: "#fff !important",
        "&:hover": {
            color: "#fff !important",
        },
        "& .MuiTableSortLabel-icon": {
            color: "#fff !important",
        },
    },
    tableRow: {
        "&:nth-of-type(odd)": {
            backgroundColor: "#fbfbfb",
        },
        "&:hover": {
            backgroundColor: ORANGE_LIGHT,
        },
        transition: "background-color .15s ease",
    },
    tableCell: {
        fontSize: 14,
        color: "#333",
    },
    nameCell: {
        display: "flex",
        alignItems: "center",
        gap: 10,
    },
    avatarChip: {
        width: 34,
        height: 34,
        borderRadius: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: 14,
        flexShrink: 0,
    },
    stageCountChip: {
        height: 26,
        fontSize: 12,
        fontWeight: 600,
        backgroundColor: ORANGE_LIGHT,
        color: ORANGE_DARK,
        cursor: "pointer",
        transition: "transform .15s ease, background-color .15s ease",
        "&:hover": { backgroundColor: "#ffe3d2", transform: "scale(1.05)" },
    },
    drawerPaper: {
        width: 400,
        maxWidth: "90vw",
    },
    drawerHeader: {
        position: "relative",
        background: HEADER_GRADIENT,
        color: "#fff",
        padding: "26px 24px",
        overflow: "hidden",
    },
    drawerHeaderGlow: {
        position: "absolute",
        top: -50,
        right: -30,
        width: 140,
        height: 140,
        borderRadius: "50%",
        background: "rgba(255,255,255,0.14)",
        pointerEvents: "none",
    },
    drawerHeaderTop: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
        zIndex: 1,
    },
    drawerCloseBtn: {
        color: "#fff",
    },
    drawerTitleWrap: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        marginTop: 14,
        position: "relative",
        zIndex: 1,
    },
    drawerIconBadge: {
        width: 46,
        height: 46,
        borderRadius: 14,
        background: "rgba(255,255,255,0.22)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 22,
        flexShrink: 0,
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.25)",
    },
    drawerDeptName: {
        fontFamily: HEADING_FONT,
        fontSize: 19,
        margin: 0,
    },
    drawerDeptSub: {
        fontSize: 12.5,
        color: "rgba(255,255,255,0.85)",
        margin: "3px 0 0",
    },
    drawerBody: {
        padding: "26px 26px 30px",
        overflowY: "auto",
    },
    timelineItem: {
        position: "relative",
        display: "flex",
        alignItems: "flex-start",
    },
    timelineNodeCol: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginRight: 16,
    },
    timelineNode: {
        width: 32,
        height: 32,
        borderRadius: "50%",
        background: HEADER_GRADIENT,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: 13,
        flexShrink: 0,
        boxShadow: "0 3px 10px rgba(244,126,68,0.4)",
        zIndex: 1,
    },
    timelineConnector: {
        flex: 1,
        width: 2,
        minHeight: 28,
        marginTop: 2,
        background: "linear-gradient(to bottom, #f3b998, #ffe3d2)",
    },
    timelineCard: {
        flex: 1,
        background: "#fff8f4",
        border: "1px solid #ffe3d2",
        borderRadius: 12,
        padding: "12px 16px",
        fontSize: 14,
        fontWeight: 600,
        color: "#3a3a3a",
        marginBottom: 20,
        marginTop: -2,
        transition: "transform .15s ease, box-shadow .15s ease",
        "&:hover": {
            transform: "translateX(3px)",
            boxShadow: "0 4px 12px rgba(244,126,68,0.15)",
        },
    },
    drawerEmptyState: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "60px 20px",
        color: "#9b9b9b",
        textAlign: "center",
    },
    actionCell: {
        display: "flex",
        gap: 8,
    },
    editBtn: {
        color: ORANGE_DARK,
        backgroundColor: ORANGE_LIGHT,
        transition: "transform .15s ease, background-color .15s ease",
        "&:hover": { backgroundColor: "#ffe3d2", transform: "scale(1.08)" },
    },
    deleteBtn: {
        color: RED,
        backgroundColor: RED_LIGHT,
        transition: "transform .15s ease, background-color .15s ease",
        "&:hover": { backgroundColor: "#fadbd8", transform: "scale(1.08)" },
    },
    emptyState: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "64px 20px",
        color: "#9b9b9b",
        background: "#fff",
    },
    emptyIcon: {
        fontSize: 46,
        color: "#e0b8a4",
        marginBottom: 12,
    },
    emptyTitle: {
        fontSize: 15,
        fontWeight: 600,
        color: "#666",
    },
    emptyHint: {
        fontSize: 13,
        color: "#aaa",
        marginTop: 4,
    },
    pagination: {
        borderTop: "1px solid #f0f0f0",
    },
    dialogHeader: {
        background: HEADER_GRADIENT,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "18px 24px",
    },
    dialogHeaderDelete: {
        background: `linear-gradient(135deg, #922b21, ${RED})`,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "18px 24px",
    },
    dialogTitleWrap: {
        display: "flex",
        alignItems: "center",
        gap: 10,
    },
    dialogIconBadge: {
        width: 34,
        height: 34,
        borderRadius: 10,
        background: "rgba(255,255,255,0.22)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 17,
    },
    dialogTitleText: {
        fontFamily: HEADING_FONT,
        fontSize: 18,
    },
    dialogCloseBtn: {
        color: "#fff",
    },
    dialogContent: {
        padding: "26px 24px 10px",
    },
    inputField: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 10,
            "&.Mui-focused fieldset": {
                borderColor: ORANGE,
            },
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: ORANGE_DARK,
        },
    },
    addStageBtn: {
        color: "#fff",
        backgroundColor: ORANGE,
        borderRadius: 10,
        marginLeft: 8,
        transition: "transform .15s ease, background-color .15s ease",
        "&:hover": { backgroundColor: ORANGE_DARK, transform: "scale(1.06)" },
    },
    stagesLabel: {
        fontSize: 12,
        fontWeight: 700,
        color: "#8a8a8a",
        textTransform: "uppercase",
        letterSpacing: 0.5,
        marginBottom: 8,
        marginTop: 4,
        display: "block",
    },
    stageChipsWrap: {
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
        minHeight: 40,
        padding: "10px 12px",
        borderRadius: 10,
        border: "1px dashed #e2c6b6",
        background: "#fffaf7",
    },
    stageChip: {
        backgroundColor: ORANGE_LIGHT,
        color: ORANGE_DARK,
        fontWeight: 600,
    },
    noStagesHint: {
        fontSize: 13,
        color: "#bbb",
        alignSelf: "center",
    },
    submitBtn: {
        background: HEADER_GRADIENT,
        color: "#fff",
        fontWeight: 600,
        textTransform: "none",
        borderRadius: 10,
        padding: "8px 22px",
        "&:hover": {
            background: HEADER_GRADIENT,
            opacity: 0.92,
        },
    },
    cancelBtn: {
        color: "#666",
        textTransform: "none",
        fontWeight: 600,
    },
    deleteConfirmBtn: {
        background: `linear-gradient(135deg, #922b21, ${RED})`,
        color: "#fff",
        fontWeight: 600,
        textTransform: "none",
        borderRadius: 10,
        padding: "8px 22px",
        "&:hover": {
            background: `linear-gradient(135deg, #922b21, ${RED})`,
            opacity: 0.92,
        },
    },
    warningIconWrap: {
        width: 64,
        height: 64,
        borderRadius: "50%",
        background: RED_LIGHT,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 14px",
    },
    warningIcon: {
        fontSize: 30,
        color: RED,
    },
});

const StyledTableCell = withStyles(() => ({
    head: {
        border: "none",
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const emptyForm = { _id: "", name: "", stages: [] };

const ManageDepartment = (props) => {
    const classes = useStyles();

    const [departments, setDepartmentsList] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const [deptModalOpen, setDeptModalOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [deptForm, setDeptForm] = useState(emptyForm);
    const [stageInput, setStageInput] = useState("");
    const [nameError, setNameError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const [deleteTarget, setDeleteTarget] = useState(null);
    const [deleting, setDeleting] = useState(false);
    // When the list on screen was last pulled. Only set on a SUCCESSFUL fetch,
    // so a failed refresh never makes stale rows look fresh.
    const [lastUpdated, setLastUpdated] = useState(null);
    // "Updated 4 minutes ago" is only true at the instant it renders, so a slow
    // tick re-renders it. 30s is plenty - moment rounds to the minute anyway.
    const [nowTick, setNowTick] = useState(Date.now());

    useEffect(() => {
        const id = setInterval(() => setNowTick(Date.now()), 30000)
        return () => clearInterval(id)
    }, []);

    const [stagesDrawerDept, setStagesDrawerDept] = useState(null);

    const openStagesDrawer = (dept) => setStagesDrawerDept(dept);
    const closeStagesDrawer = () => setStagesDrawerDept(null);

    useEffect(() => {
        getDepartments()
        // eslint-disable-next-line
    }, [])

    const getDepartments = async () => {
        setDataLoading(true)
        try {
            const department = await HttpService.getDepartments();
            setDepartmentsList(department.data);
            // Inside the try, after the assignment: a fetch that threw leaves
            // the previous timestamp alone rather than vouching for stale data.
            setLastUpdated(moment());
        } catch (error) {
            console.error(error)
            setDepartmentsList([])
            props.setSnackInfo(extractErrorMessage(error), "error")
        }
        setDataLoading(false)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Only changes the page size/index - the previous version also reset the
    // department list to the number 0 here, which crashed the table the
    // moment anyone changed rows-per-page (0.slice is not a function).
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const toggleSort = () => {
        setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
    };

    const findDuplicateDepartment = (name, excludeId) => {
        const normalizedName = name?.trim().toLowerCase()
        if (!normalizedName) return null
        return departments.find((dept) =>
            dept?._id !== excludeId && dept?.name?.trim().toLowerCase() === normalizedName
        ) || null
    };

    const openAddModal = () => {
        setDeptForm(emptyForm);
        setStageInput("");
        setNameError("");
        setIsEdit(false);
        setDeptModalOpen(true);
    };

    const openEditModal = (dept) => {
        setDeptForm({ _id: dept._id, name: dept.name, stages: Array.isArray(dept.stages) ? [...dept.stages] : [] });
        setStageInput("");
        setNameError("");
        setIsEdit(true);
        setDeptModalOpen(true);
    };

    const closeModal = () => {
        setDeptModalOpen(false);
        setDeptForm(emptyForm);
        setStageInput("");
        setNameError("");
    };

    const handleAddStage = () => {
        const trimmed = stageInput.trim();
        if (!trimmed) return;
        if (deptForm.stages.some((s) => s.trim().toLowerCase() === trimmed.toLowerCase())) {
            props.setSnackInfo("This stage has already been added", "error");
            return;
        }
        setDeptForm((prev) => ({ ...prev, stages: [...prev.stages, trimmed] }));
        setStageInput("");
    };

    const handleRemoveStage = (index) => {
        setDeptForm((prev) => ({ ...prev, stages: prev.stages.filter((_, i) => i !== index) }));
    };

    const handleSave = async () => {
        if (!deptForm.name?.trim()) {
            setNameError("Please enter a department name");
            return;
        }
        const duplicate = findDuplicateDepartment(deptForm.name, deptForm._id);
        if (duplicate) {
            setNameError(`"${duplicate.name}" already exists. Please use a different name.`);
            return;
        }
        setSubmitting(true);
        try {
            if (isEdit) {
                await HttpService.editDepartment({ name: deptForm.name, stages: deptForm.stages }, deptForm._id);
                props.setSnackInfo("Department Updated Successfully", "success");
            } else {
                await HttpService.createDepartment({ name: deptForm.name, stages: deptForm.stages });
                props.setSnackInfo("Department Added Successfully", "success");
            }
            closeModal();
            getDepartments();
        } catch (error) {
            console.error(error);
            props.setSnackInfo(extractErrorMessage(error), "error");
        }
        setSubmitting(false);
    };

    const confirmDeleteDepartment = async () => {
        if (!deleteTarget) return;
        setDeleting(true);
        try {
            await HttpService.deleteDepartment(deleteTarget._id);
            props.setSnackInfo('Department Deleted', 'success');
            setDeleteTarget(null);
            getDepartments();
        } catch (error) {
            console.error(error);
            props.setSnackInfo(extractErrorMessage(error), "error")
        }
        setDeleting(false);
    };

    const filteredList = useMemo(() => {
        let list = [...departments]
        if (searchText.trim()) {
            const q = searchText.trim().toLowerCase()
            list = list.filter((dept) => dept?.name?.toLowerCase().includes(q))
        }
        list.sort((a, b) => {
            const cmp = (a?.name || "").localeCompare(b?.name || "")
            return sortOrder === "asc" ? cmp : -cmp
        })
        return list
    }, [departments, searchText, sortOrder]);

    const paginatedList = useMemo(() => {
        const start = page * rowsPerPage
        return filteredList.slice(start, start + rowsPerPage)
    }, [filteredList, page, rowsPerPage]);

    useEffect(() => {
        setPage(0)
    }, [searchText]);

    const totalStages = useMemo(() => {
        return departments.reduce((sum, dept) => sum + (Array.isArray(dept?.stages) ? dept.stages.length : 0), 0)
    }, [departments]);

    // A department with no stages has no pipeline for its leads to move
    // through, so it is the one broken state this page can show. The table
    // already rendered a grey "No stages" - this names it up front, where it
    // can be acted on, and only when there is something to report.
    const noStageCount = useMemo(() => {
        return departments.filter((d) => !Array.isArray(d?.stages) || d.stages.length === 0).length
    }, [departments]);

    return (
        <div className={classes.page}>
            <div className={classes.headerCard}>
                <div className={classes.headerGlowOne} />
                <div className={classes.headerGlowTwo} />
                <div className={classes.headerLeft}>
                    <div className={classes.iconBadge}>
                        <BusinessOutlinedIcon />
                    </div>
                    <div>
                        <h2 className={classes.headerTitle}>Departments</h2>
                        <p className={classes.headerSubtitle}>Manage departments and their pipeline stages</p>
                    </div>
                    <Chip className={classes.statChip} icon={<BusinessOutlinedIcon style={{ color: "#fff" }} />} label={`${departments.length} Department${departments.length === 1 ? "" : "s"}`} />
                    <Chip className={classes.statChip} icon={<LayersOutlinedIcon style={{ color: "#fff" }} />} label={`${totalStages} Total Stage${totalStages === 1 ? "" : "s"}`} />
                    {/* Only when there is something to report - a permanent
                        "0 without stages" chip would become background noise. */}
                    {noStageCount > 0 && (
                        <Tooltip title="These departments have no stages defined, so leads in them have no pipeline to move through. Edit each to add its stages.">
                            <Chip
                                className={classes.warnChip}
                                icon={<ReportProblemOutlinedIcon style={{ color: "#fff" }} />}
                                label={`${noStageCount} without stages`}
                            />
                        </Tooltip>
                    )}
                </div>
                <div className={classes.headerActions}>
                    <Tooltip
                        title={
                            lastUpdated
                                ? `Last loaded at ${lastUpdated.format("DD MMM YYYY, hh:mm:ss A")} — click to reload`
                                : "Reload the departments"
                        }
                    >
                        {/* A disabled button fires no mouse events, so the
                            tooltip would die exactly when it is most wanted -
                            mid-refresh. */}
                        <span style={{ display: "inline-flex" }}>
                            <Button
                                className={classes.refreshBtn}
                                onClick={getDepartments}
                                disabled={dataLoading}
                                startIcon={<RefreshIcon className={dataLoading ? classes.spin : ""} />}
                            >
                                {dataLoading ? "Refreshing…" : "Refresh"}
                            </Button>
                        </span>
                    </Tooltip>
                    <Button
                        className={classes.addBtn}
                        startIcon={<AddIcon />}
                        onClick={openAddModal}
                    >
                        Add Department
                    </Button>
                    {lastUpdated && (
                        <div className={classes.lastUpdatedText}>
                            <span className={classes.liveDot} />
                            {dataLoading ? "Loading…" : `Updated ${moment(lastUpdated).from(nowTick)}`}
                        </div>
                    )}
                </div>
            </div>

            <div className={classes.filterCard}>
                <span className={classes.sectionLabel}>Search</span>
                <TextField
                    className={classes.searchField}
                    size="small"
                    variant="outlined"
                    placeholder="Search by department name"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon style={{ color: "#aaa" }} />
                            </InputAdornment>
                        ),
                    }}
                />
                {searchText && (
                    <Button
                        className={classes.clearBtn}
                        size="small"
                        startIcon={<ClearAllIcon />}
                        onClick={() => setSearchText("")}
                    >
                        Clear
                    </Button>
                )}
                <span className={classes.resultCount}>
                    {filteredList.length} of {departments.length} shown
                </span>
            </div>

            {/* Reserved slot rather than a conditional element, so starting a
                fetch does not jog the table down by 4px and back again. */}
            <div className={classes.progressSlot}>
                {dataLoading ? <BrandLinearProgress /> : null}
            </div>

            {/* The bar alone says "something is happening"; this says WHAT,
                which matters most on a refresh - the rows stay on screen then,
                so without it there is nothing to explain why they have not
                changed yet. */}
            {dataLoading && (
                <div className={classes.loadingBanner}>
                    <CircularProgress size={17} thickness={5} style={{ color: ORANGE_DARK }} />
                    <div style={{ minWidth: 0 }}>
                        <div className={classes.loadingBannerTitle}>Fetching departments…</div>
                        <div className={classes.loadingBannerHint}>
                            {departments.length
                                ? "Reloading the list — the departments below stay visible until the new data lands."
                                : "Pulling every department and the stages defined under it."}
                        </div>
                    </div>
                </div>
            )}

            <Paper className={classes.tableCard}>
                {dataLoading && departments.length === 0 ? (
                    // Placeholder rows shaped like real ones, so the card keeps
                    // its height and column rhythm instead of collapsing to a
                    // spinner and snapping back when the data lands. A REFRESH
                    // (list already populated) keeps the existing rows on screen
                    // rather than blanking them.
                    <TableContainer className={classes.tableScrollWrap}>
                        <Table className={classes.table} size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {["Sl No", "Department", "Stages", "Action"].map((h) => (
                                        <StyledTableCell key={h} className={classes.tableHeadCell}>{h}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.from({ length: 8 }).map((_, i) => (
                                    <TableRow key={i}>
                                        <StyledTableCell className={classes.tableCell}><Skeleton variant="text" width={20} /></StyledTableCell>
                                        <StyledTableCell className={classes.tableCell}>
                                            <div className={classes.nameCell}>
                                                <Skeleton variant="circle" width={30} height={30} />
                                                <Skeleton variant="text" width={150} />
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.tableCell}><Skeleton variant="rect" width={92} height={22} style={{ borderRadius: 999 }} /></StyledTableCell>
                                        <StyledTableCell className={classes.tableCell}><Skeleton variant="rect" width={64} height={26} style={{ borderRadius: 8 }} /></StyledTableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : filteredList.length === 0 ? (
                    <div className={classes.emptyState}>
                        <InboxOutlinedIcon className={classes.emptyIcon} />
                        <span className={classes.emptyTitle}>{searchText ? "No departments match your search" : "No departments added yet"}</span>
                        <span className={classes.emptyHint}>{searchText ? "Try a different name" : "Click \"Add Department\" to create the first one"}</span>
                    </div>
                ) : (
                    <>
                        <TableContainer className={classes.tableScrollWrap}>
                            <Table className={classes.table} size="small" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell className={classes.tableHeadCell}>Sl No</StyledTableCell>
                                        <StyledTableCell className={classes.tableHeadCell} sortDirection={sortOrder}>
                                            <TableSortLabel className={classes.sortLabel} active direction={sortOrder} onClick={toggleSort}>
                                                Department
                                            </TableSortLabel>
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.tableHeadCell}>Stages</StyledTableCell>
                                        <StyledTableCell className={classes.tableHeadCell}>Action</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedList?.map((data, i) => {
                                        const avatarColor = getAvatarColor(data?.name)
                                        const stages = Array.isArray(data?.stages) ? data.stages : []
                                        return (
                                            <TableRow key={data?._id || i} className={classes.tableRow}>
                                                <StyledTableCell className={classes.tableCell}>{page * rowsPerPage + i + 1}</StyledTableCell>
                                                <StyledTableCell className={classes.tableCell}>
                                                    <div className={classes.nameCell}>
                                                        <div className={classes.avatarChip} style={{ backgroundColor: avatarColor.bg, color: avatarColor.fg }}>
                                                            {data?.name?.charAt(0)?.toUpperCase() || "?"}
                                                        </div>
                                                        {data?.name}
                                                    </div>
                                                </StyledTableCell>
                                                <StyledTableCell className={classes.tableCell}>
                                                    {stages.length > 0 ? (
                                                        <Chip
                                                            size="small"
                                                            icon={<LayersOutlinedIcon style={{ fontSize: 13, color: ORANGE_DARK }} />}
                                                            deleteIcon={<ChevronRightIcon style={{ fontSize: 11, color: ORANGE_DARK }} />}
                                                            onDelete={() => openStagesDrawer(data)}
                                                            label={`${stages.length} Stage${stages.length === 1 ? "" : "s"}`}
                                                            className={classes.stageCountChip}
                                                            onClick={() => openStagesDrawer(data)}
                                                        />
                                                    ) : (
                                                        // Not grey filler: with no stages this
                                                        // department has no pipeline, so it is
                                                        // flagged where someone can act on it.
                                                        <Tooltip title="No stages defined. Leads in this department have no pipeline to move through — edit it to add stages.">
                                                            <Chip
                                                                size="small"
                                                                className={classes.noStageChip}
                                                                icon={<ReportProblemOutlinedIcon style={{ fontSize: 13, color: RED }} />}
                                                                label="No stages"
                                                            />
                                                        </Tooltip>
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell className={classes.tableCell}>
                                                    <div className={classes.actionCell}>
                                                        <Tooltip title="Edit Department">
                                                            <IconButton size="small" className={classes.editBtn} onClick={() => openEditModal(data)}>
                                                                <EditOutlinedIcon style={{ fontSize: 16 }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Delete Department">
                                                            <IconButton size="small" className={classes.deleteBtn} onClick={() => setDeleteTarget(data)}>
                                                                <DeleteOutlineIcon style={{ fontSize: 16 }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                </StyledTableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            className={classes.pagination}
                            component="div"
                            count={filteredList.length}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={[25, 50, 100]}
                        />
                    </>
                )}
            </Paper>

            <Dialog
                open={deptModalOpen}
                TransitionComponent={Transition}
                keepMounted
                fullWidth
                maxWidth="sm"
                onClose={closeModal}
            >
                <div className={classes.dialogHeader}>
                    <div className={classes.dialogTitleWrap}>
                        <div className={classes.dialogIconBadge}>
                            <BusinessOutlinedIcon />
                        </div>
                        <span className={classes.dialogTitleText}>{isEdit ? "Edit Department" : "Add Department"}</span>
                    </div>
                    <IconButton size="small" className={classes.dialogCloseBtn} onClick={closeModal}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <DialogContent className={classes.dialogContent}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                className={classes.inputField}
                                label="Department Name"
                                variant="outlined"
                                autoFocus
                                error={!!nameError}
                                helperText={nameError}
                                onChange={(e) => {
                                    setDeptForm({ ...deptForm, name: e.target.value });
                                    if (nameError) setNameError("");
                                }}
                                value={deptForm.name}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <BusinessOutlinedIcon style={{ color: nameError ? RED : "#aaa" }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box style={{ display: "flex", alignItems: "flex-start" }}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    className={classes.inputField}
                                    label="Add a Stage"
                                    variant="outlined"
                                    value={stageInput}
                                    onChange={(e) => setStageInput(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            handleAddStage();
                                        }
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <LocalOfferOutlinedIcon style={{ color: "#aaa" }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Tooltip title="Add stage">
                                    <IconButton className={classes.addStageBtn} onClick={handleAddStage}>
                                        <AddCircleOutlineIcon style={{ fontSize: 18 }} />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <span className={classes.stagesLabel}>Pipeline Stages</span>
                            <div className={classes.stageChipsWrap}>
                                {deptForm.stages.length === 0 ? (
                                    <span className={classes.noStagesHint}>No stages added yet</span>
                                ) : (
                                    deptForm.stages.map((stage, i) => (
                                        <Chip
                                            key={`${stage}-${i}`}
                                            label={stage}
                                            size="small"
                                            onDelete={() => handleRemoveStage(i)}
                                            className={classes.stageChip}
                                        />
                                    ))
                                )}
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ padding: "16px 24px 22px" }}>
                    <Button className={classes.cancelBtn} onClick={closeModal}>
                        Cancel
                    </Button>
                    <Button
                        className={classes.submitBtn}
                        onClick={handleSave}
                        disabled={submitting}
                        startIcon={submitting ? <CircularProgress size={16} style={{ color: "#fff" }} /> : null}
                    >
                        {isEdit ? "Update Department" : "Save Department"}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={!!deleteTarget}
                TransitionComponent={Transition}
                keepMounted
                fullWidth
                maxWidth="xs"
                onClose={() => setDeleteTarget(null)}
            >
                <div className={classes.dialogHeaderDelete}>
                    <span className={classes.dialogTitleText}>Delete Department</span>
                    <IconButton size="small" className={classes.dialogCloseBtn} onClick={() => setDeleteTarget(null)}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <DialogContent className={classes.dialogContent} style={{ textAlign: "center" }}>
                    <div className={classes.warningIconWrap}>
                        <ReportProblemOutlinedIcon className={classes.warningIcon} />
                    </div>
                    <p style={{ fontSize: 15, color: "#333", margin: 0 }}>
                        Are you sure you want to delete <strong>{deleteTarget?.name}</strong>?
                    </p>
                    <p style={{ fontSize: 13, color: "#999", marginTop: 6 }}>
                        {Array.isArray(deleteTarget?.stages) && deleteTarget.stages.length > 0
                            ? `This will also remove its ${deleteTarget.stages.length} pipeline stage${deleteTarget.stages.length === 1 ? "" : "s"}. This action cannot be undone.`
                            : "This action cannot be undone."}
                    </p>
                </DialogContent>
                <DialogActions style={{ padding: "16px 24px 22px", justifyContent: "center" }}>
                    <Button className={classes.cancelBtn} onClick={() => setDeleteTarget(null)}>
                        Cancel
                    </Button>
                    <Button
                        className={classes.deleteConfirmBtn}
                        onClick={confirmDeleteDepartment}
                        disabled={deleting}
                        startIcon={deleting ? <CircularProgress size={16} style={{ color: "#fff" }} /> : null}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            <Drawer
                anchor="right"
                open={!!stagesDrawerDept}
                onClose={closeStagesDrawer}
                classes={{ paper: classes.drawerPaper }}
            >
                <div className={classes.drawerHeader}>
                    <div className={classes.drawerHeaderGlow} />
                    <div className={classes.drawerHeaderTop}>
                        <Chip className={classes.statChip} icon={<LayersOutlinedIcon style={{ color: "#fff" }} />} label={`${stagesDrawerDept?.stages?.length || 0} Stage${(stagesDrawerDept?.stages?.length || 0) === 1 ? "" : "s"}`} />
                        <IconButton size="small" className={classes.drawerCloseBtn} onClick={closeStagesDrawer}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div className={classes.drawerTitleWrap}>
                        <div className={classes.drawerIconBadge}>
                            <BusinessOutlinedIcon />
                        </div>
                        <div>
                            <h3 className={classes.drawerDeptName}>{stagesDrawerDept?.name}</h3>
                            <p className={classes.drawerDeptSub}>Pipeline Stages</p>
                        </div>
                    </div>
                </div>
                <div className={classes.drawerBody}>
                    {!stagesDrawerDept?.stages?.length ? (
                        <div className={classes.drawerEmptyState}>
                            <InboxOutlinedIcon className={classes.emptyIcon} />
                            <span className={classes.emptyTitle}>No stages added yet</span>
                        </div>
                    ) : (
                        stagesDrawerDept.stages.map((stage, idx) => {
                            const isLast = idx === stagesDrawerDept.stages.length - 1
                            return (
                                <div className={classes.timelineItem} key={`${stage}-${idx}`}>
                                    <div className={classes.timelineNodeCol}>
                                        <div className={classes.timelineNode}>
                                            {idx + 1}
                                        </div>
                                        {!isLast && <div className={classes.timelineConnector} />}
                                    </div>
                                    <div className={classes.timelineCard}>{stage}</div>
                                </div>
                            )
                        })
                    )}
                </div>
            </Drawer>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(ManageDepartment)
